import Vue from 'vue';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';

import GigsPage from '../components/gigs_page/index.vue';

Vue.use(VueApollo);

document.addEventListener('DOMContentLoaded', () => {
  const csrfToken = document.head.querySelector('[name=csrf-token]').content;

  const apolloProvider = new VueApollo({
    defaultClient: new ApolloClient({
      uri: '/graphql',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-TOKEN': csrfToken,
      },
    }),
  });

  const allData = document.getElementById('gigsPage').dataset;

  const gigsPage = new Vue({
    el: '#gigsPage',
    apolloProvider,
    render: h => h(GigsPage, {
      props: {
        country: allData.country,
        advert: allData.advert ? JSON.parse(allData.advert) : null,
      },
    }),
  });
});
